export enum DateFormat {
  displayDateTime = 'dd - MM - yyyy @ HH:mm',
  displayDateTimeSeconds = 'dd - MM - yyyy @ HH:mm:ss',
  displayDate = 'dd - MM - yyyy',
  DisplayStandardDateTime = 'yyyy-MM-dd HH:mm:ss',
}
